<!-- @format -->

<ng-container *transloco="let t">
  <ng-container
    *ngIf="{
      isMobileView: isMobileView$ | async,
      parameters: searchService.searchParameters$ | async,
      searchFilterCount: searchFilterCount$ | async,
    } as context">
    <div class="row align-items-baseline">
      <div *ngIf="context.parameters?.filters?.universityOrgId | organisation | async as university" class="col-lg-2">
        <label id="university-select-editor-label">{{ t("SEARCH.UNIVERSITY_LABEL") }}</label>
        <sis-university-select-editor
          [ariaLabelledBy]="'university-select-editor-label'"
          [placeOnLeft]="true"
          [onlySisuOrganisations]="true"
          [university]="university"
          (universityChange)="selectUniversity($event?.id)">
        </sis-university-select-editor>
      </div>
      @if (isTextSearchEnabled) {
        <div [ngClass]="getTextSearchInputContainerClass(context.parameters)">
          <label for="full-text-query-input">{{ t("SEARCH.INPUT_LABEL") }}</label>
          <div class="search-group">
            <input
              #fullTextQueryInput
              id="full-text-query-input"
              data-cy="full-text-query-input"
              class="form-control"
              [value]="context.parameters?.filters?.fullTextQuery || ''"
              (keyup.enter)="searchButtonTriggered()"
              [attr.aria-describedby]="'search-guidance search-error-message'" />
            <sis-button
              class="search-trigger-button"
              [dataCy]="'search-trigger-button'"
              [ariaLabel]="t(ariaLabel)"
              (clicked)="searchButtonTriggered()"
              [ngClass]="'btn-search'">
              <sis-icon color="white" icon="search" aria-hidden="true" />
              {{ t("SEARCH.PLACEHOLDER_SEARCH") }}
            </sis-button>
          </div>
          <p class="sis-guidance sis-guidance__primary" id="search-guidance">{{ t(guidance) }}</p>
        </div>
      }
    </div>
    <sis-expandable
      *ngIf="searchFilterTemplates?.length > 0"
      [variant]="'link'"
      [title]="searchFiltersTitle(context.searchFilterCount)"
      [closed]="context.isMobileView || !areSearchFiltersAllowed"
      [disabled]="!areSearchFiltersAllowed"
      [closed]="closedByDefault"
      data-cy="search-filters-expandable">
      <ng-template sisExpandableContent>
        <div class="row search-filter-row align-items-baseline">
          @for (template of searchFilterTemplates; track $index) {
            @if (template.subtitle) {
              <fudis-heading [level]="subtitleLevel" [class]="'fudis-mt-md fudis-mb-md'">{{ template.subtitle }}</fudis-heading>
            }
            @if (template?.singleFilterComponent) {
              <div class="col-lg-6 fudis-mb-sm">
                <ng-container [ngTemplateOutlet]="template?.templateRef"></ng-container>
              </div>
            } @else {
              <div class="col-lg-3 fudis-mb-sm">
                <ng-container [ngTemplateOutlet]="template?.templateRef"></ng-container>
              </div>
            }
          }
        </div>
        @if (context.searchFilterCount > 0) {
          <fudis-button
            (handleClick)="clearSearchFilters(context?.parameters)"
            [label]="t('SEARCH.CLEAR_SEARCH_FILTERS')"
            [variant]="'tertiary'"
            [icon]="'close'"
            data-cy="clear-search-filters-button"
            [class]="'fudis-mt-md fudis-mb-md'" />
        }
      </ng-template>
    </sis-expandable>
  </ng-container>
</ng-container>
